// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"20c46b56","94":"c7ac1fc2","201":"db3e90cf","202":"3b3e2511","265":"a6c7ddbd","439":"d8877b76"}[chunkId] + ".chunk.js";
};